import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductOfferSelection } from 'components/product-offer-selection';
import Title from 'ui-library/components/Title/Title';
import './ProductSelectionThreeB.css';

const ProductSelectionThreeB = ({ datasource }) => {
    const { t } = useTranslation();
    const { productOffers, selectProductOfferId, onSelectedProductOfferChange, selectedProposalOwner } = datasource() || {};

    return (
        <div>
            <Title type="3" className="font-normal ProductSelectionThreeB-subtitle">
                {t('createNewProposal.Select3bProducts.proposalOwner.title')}
                {': '}
                {selectedProposalOwner?.name}
            </Title>
            <div className="fi-products-selection">
                {productOffers?.map(productOffer => (
                    <ProductOfferSelection
                        key={productOffer.id}
                        disabled={false}
                        productOffer={productOffer}
                        isSelected={selectProductOfferId === productOffer.id}
                        onSelectionChange={onSelectedProductOfferChange}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProductSelectionThreeB;
